import { fetchAuthenticated } from 'services/fetch';
export async function logAction(description) {
  try {
    fetchAuthenticated('post', 'logs', { description });
  } catch (err) {
    console.log(err);
  }
}